import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrainingDashboard } from '../components/training/TrainingDashboard';
import { CorrectionHistory } from '../components/training/CorrectionHistory';
import { PracticeList } from '../components/training/PracticeList';
import { LearningTrend } from '../components/training/LearningTrend';
import type { CorrectionRecord, PracticeRecord } from '../components/training/TrainingDashboard';
import styles from './TrainingPage.module.css';

type TrainingTab = 'dashboard' | 'corrections' | 'practices' | 'trends';

// Empty mock data — will be replaced with real BuilderTrend data
const MOCK_CORRECTIONS: CorrectionRecord[] = [];
const MOCK_PRACTICES: PracticeRecord[] = [];

export default function TrainingPage() {
  const [activeTab, setActiveTab] = useState<TrainingTab>('dashboard');
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <button className={styles.backLink} onClick={() => navigate('/')}>
        &larr; Back to Chat
      </button>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'dashboard' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          Dashboard
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'corrections' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('corrections')}
        >
          Corrections
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'practices' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('practices')}
        >
          Practices
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'trends' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('trends')}
        >
          Trends
        </button>
      </div>

      <div className={styles.content}>
        {activeTab === 'dashboard' && (
          <TrainingDashboard
            corrections={MOCK_CORRECTIONS}
            practices={MOCK_PRACTICES}
          />
        )}
        {activeTab === 'corrections' && (
          <CorrectionHistory corrections={MOCK_CORRECTIONS} />
        )}
        {activeTab === 'practices' && (
          <PracticeList practices={MOCK_PRACTICES} />
        )}
        {activeTab === 'trends' && (
          <LearningTrend
            corrections={MOCK_CORRECTIONS}
            practices={MOCK_PRACTICES}
          />
        )}
      </div>
    </div>
  );
}
